import React, { Component } from 'react';
import { Card, CardBody, CardHeader, Col, Input, Label } from 'reactstrap';
import { Link } from 'react-router-dom';
import ReactTable from 'react-table';
import CompanyContext from '../../../auth/CompanyContext';
class LandingMyOpportunities extends Component {
  static contextType = CompanyContext;

  constructor(props) {
    super(props);
    this.state = {
      opportunities: [],
      isLoading: false,
      showMyOpportunitiesOnly: true
    }
  }

  componentDidMount = () => {
    this.getOpportunities();
  };

  getOpportunities = () => {
    this.setState({
      isLoading: true
    }, () => {
      fetch('/api/marketing2Opportunities/', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.props.clientToken,
          'X-Database': this.context.company,
          'X-type': 'opportunity',
          'X-auth0': this.state.showMyOpportunitiesOnly ? this.props.user : ''
        }
      })
        .then(results => results.json())
        .then(results => {
          if ("data" in results) {
            this.setState({
              opportunities: results.data,
              isLoading: false
            })
          }
        });
    })
  }

  render() {
    return (
      <Card className='w-100 m-0'>
        <CardHeader className="d-flex justify-content-between align-items-center">
          <h4>My Opportunities</h4>
          {/* <Row> */}
          <Col className="text-right ">
            <Label>
              <Input
                type="checkbox"
                name="showMyOpportunitiesOnly"
                checked={this.state.showMyOpportunitiesOnly}
                onChange={() => {
                  this.setState({
                    showMyOpportunitiesOnly: !this.state.showMyOpportunitiesOnly
                  }, () => this.getOpportunities())
                }}
              />
              Show My Opportunities Only
            </Label>
          </Col>
          {/* </Row> */}
          {this.props.icon}
        </CardHeader>
        <CardBody className='p-0'>
          <ReactTable
            data={this.state.opportunities}
            loading={this.state.isLoading}
            columns={[
              {
                Header: 'WA#',
                accessor: 'WA#',
                filterable: true,
                width: 75,
                headerStyle: { textAlign: 'left' },
                Cell: row => row.value || `WA${row.original.ID}`
              },
              {
                Header: 'Opportunity',
                accessor: 'Sales Opportunity Name',
                filterable: true,
                headerStyle: { textAlign: 'left' },
                Cell: row =>
                (<Link
                  onClick={() => {
                    localStorage.setItem('demographicsActiveTab', 3)
                  }}
                  to={{
                    pathname: '/demographics/' + row.original['SEC#'],
                    state: {}
                  }}
                >{row.original['Sales Opportunity Name']}</Link>)
              },
              {
                Header: 'Type',
                accessor: 'Type',
                filterable: true,
                headerStyle: { textAlign: 'left' },
                width: 120,
                // Cell: row => row.original.source === 'sec' ? 'Company' : 'Contact'
              },
              {
                Header: 'Sales Rep',
                id: 'Sales Rep',
                accessor: d =>
                  `${d['Opportunity Sales Rep User First Name'] || ''} ${d['Opportunity Sales Rep User Last Name'] || ''}`.trim(),
                filterable: true,
                width: 140,
                headerStyle: { textAlign: 'left' }
              },
              {
                Header: 'Next Steps',
                accessor: 'Next Steps',
                filterable: true,
                width: 140,
                headerStyle: { textAlign: 'left' }
              },
              {
                Header: 'Updated',
                id: 'Timestamp',           // keep same id you sort on
                accessor: 'Timestamp',     // raw data (Date or ISO string)
                filterable: true,
                width: 110,
                style: { textAlign: 'right' },
                headerStyle: { textAlign: 'right' },
                Cell: row => this.props.formatDate(row.value), // what the user sees

                // optional custom input placeholder
                Filter: ({ filter, onChange }) => (
                  <input
                    value={filter ? filter.value : ''}
                    onChange={e => onChange(e.target.value)}
                    // placeholder="MM/DD/YY or MM-DD-YY"
                    style={{ width: '100%' }}
                  />
                ),

                // normalize both sides so '-' or '/' both work, and partials match
                filterMethod: (filter, row) => {
                  const fmt = v => (this.props.formatDate ? this.props.formatDate(v) : v);
                  const norm = s => (s || '').toString().toLowerCase().replace(/\D/g, ''); // digits only
                  const rowDigits = norm(fmt(row[filter.id]));
                  const inputDigits = norm(filter.value);
                  return rowDigits.indexOf(inputDigits) !== -1;
                },
              }
            ]}
            pageSize={this.props.pageSize}
            onPageSizeChange={this.props.setPageSize}
            showPagination={true}
            defaultFilterMethod={this.props.filterCaseInsensitive}
            defaultSorted={[
              {
                id: 'Timestamp',
                desc: true
              }
            ]}
          />
        </CardBody>
      </Card>
    );

  }
}

export default LandingMyOpportunities;
